import React, { useEffect, useState } from "react";

import { IQuestionOption } from "../../../types/questionOption";

import useReorderOption from "../../../hooks/option/useReorderOption";

import { Icons } from '../../../data/Assets';

import { SVGIcon } from '../../wrappers/SVGIcon';

const SideBar = ({
  questionOptions,
  setQuestionOptions,
  currOption,
  setCurrOption,
}: {
  questionOptions: IQuestionOption[];
  setQuestionOptions: React.Dispatch<React.SetStateAction<IQuestionOption[]>>;
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const [showNewQuestionOption, setShowNewQuestionOption] =
    useState<boolean>(false);
  const [treeStack, setTreeStack] = useState<
    { quesOp: number; option: number; op_detail: number }[]
  >([]);

  const [showQuestionOption, setShowQuestionOption] = useState<Set<number>>(
    new Set()
  );
  // const [showOption, setShowOption] = useState<
  //   { quesOp: number; option: number }[]
  // >([]);
  const [showNewOption, setShowNewOption] = useState<boolean>(false);
  // const [showNewOptionDetail, setShowNewOptionDetail] =
  //   useState<boolean>(false);

  // const { mutate: reorderSection } = useReorderSection();
  // const { mutate: reorderPage } = useReorderPage();
  // const { mutate: reorderQuestion } = useReorderQuestion();
  const { mutate: reorderOption } = useReorderOption();

  const isSelect = (checkArr: number[]) => {
    if (checkArr.length !== currOption.length) return "";

    for (let i = 0; i < checkArr.length; i++) {
      if (checkArr[i] !== currOption[i]) return "";
    }
    return "selected";
  };

  const expandorContractQuestionOption = (i: number) => {
    setCurrOption([i]);

    const hasQuestionOption = treeStack.filter(
      (stack) => stack.quesOp === i
    ).length;

    if (hasQuestionOption) {
      setTreeStack((prev) => prev.filter((stack) => stack.quesOp !== i));
      const delQuestionOption = showQuestionOption;
      delQuestionOption.delete(i);
      setShowQuestionOption(delQuestionOption);
    } else {
      const oldQuestionOption = [...showQuestionOption, i];
      setShowQuestionOption(new Set([...oldQuestionOption]));
      setTreeStack([...treeStack, { quesOp: i, option: -1, op_detail: -1 }]);
    }
  };

  const swapPosOption = (i: number, j: number) => {
    reorderOption({
      id: questionOptions[currOption[0]].options[i].id ?? 0,
      action: i === j - 1 ? "down" : "up",
    })
    const newArr = [...questionOptions];
    const temp = newArr[currOption[0]].options[i];
    newArr[currOption[0]].options[i] = newArr[currOption[0]].options[j];
    newArr[currOption[0]].options[j] = temp;

    setQuestionOptions([...newArr]);
    setCurrOption([currOption[0], j]);
  }

  const moveOptionUp = () => {
    if (currOption[1] === 0) return;

    const i = currOption[1];
    const j = i - 1;
    swapPosOption(i, j);
  };

  const moveOptionDown = () => {
    if (currOption[1] === questionOptions[currOption[0]].options.length - 1) return;

    const i = currOption[1];
    const j = i + 1;
    swapPosOption(i, j);
  };

  // const expandorContractOption = (i: number, j: number) => {
  //   setCurrOption([i, j]);

  //   const hasPage = treeStack.filter(
  //     (stack) => stack.sec === i && stack.pg === j
  //   ).length;
  //   if (hasPage) {
  //     setTreeStack((prev) =>
  //       prev.filter((stack) => !(stack.sec === i && stack.pg === j))
  //     );
  //     setShowPage((prev) =>
  //       prev.filter((page) => !(page.sec === i && page.pg === j))
  //     );
  //   } else {
  //     setShowPage([...showPage, { sec: i, pg: j }]);
  //     setTreeStack([...treeStack, { sec: i, pg: j, ques: -1 }]);
  //   }
  // };

  // const isPageExpand = (sec: number, pg: number) => {
  //   const expandPage =
  //     showPage.filter((page) => page.sec === sec && page.pg === pg).length !==
  //     0;
  //   return expandPage;
  // };

  const resetStack = () => {
    setCurrOption([questionOptions.length]);
    setTreeStack([]);
    setShowQuestionOption(new Set());
    // setShowPage([]);
  };

  useEffect(() => {
    if (currOption[0] === questionOptions.length) {
      setShowNewQuestionOption(true);
    } else {
      setShowNewQuestionOption(false);
    }

    if (currOption[1] === questionOptions[currOption[0]]?.options.length) {
      setShowNewOption(true);
    } else {
      setShowNewOption(false);
    }

    // if (
    //   currOption.length > 2 &&
    //   currOption[2] ===
    //     sections[currOption[0]]?.pages[currOption[1]]?.questions.length
    // ) {
    //   setShowNewQuestion(true);
    // } else {
    //   setShowNewQuestion(false);
    // }
  }, [currOption[0], currOption[1]]); //eslint-disable-line
  // }, [currOption[0], currOption[1], currOption[2]]); //eslint-disable-line

  useEffect(() => {
    setShowNewQuestionOption(false);
  }, [questionOptions.length]); //eslint-disable-line

  const optionLen = questionOptions[currOption[0]]?.options.length || 0;
  useEffect(() => {
    setShowNewOption(false);
  }, [optionLen]);

  // const questLen =
  //   sections[currOption[0]]?.pages[currOption[1]]?.questions.length || 0;
  // useEffect(() => {
  //   setShowNewQuestion(false);
  // }, [questLen]);

  const handleCreateQuestionOptionNav = () => {
    resetStack();
    setShowNewQuestionOption(true);
  };

  const handleCreateOptionNav = (quesOpIdx: number) => {
    setCurrOption([quesOpIdx, questionOptions[quesOpIdx].options.length]);
    setShowNewOption(true);
  };

  // const handleCreateQuesNav = (secId: number, pageId: number) => {
  //   setCurrOption([
  //     secId,
  //     pageId,
  //     sections[secId].pages[pageId].questions.length,
  //   ]);
  //   setShowNewQuestion(true);
  // };

  return (
    <div className="side_bar">
      <div className="options">
        <button
          disabled={showNewQuestionOption || showNewOption}
          onClick={handleCreateQuestionOptionNav}
        >
          <SVGIcon src={Icons.Plus} />
          Ques Option
        </button>
        <button
          onClick={() => handleCreateOptionNav(currOption[0])}
          disabled={
            showNewQuestionOption ||
            showNewOption ||
            currOption.length < 1 ||
            questionOptions.length === 0
          }
        >
          <SVGIcon src={Icons.Plus} />
          Option
        </button>
        {/* <button
          onClick={() => handleCreateQuesNav(currOption[0], currOption[1])}
          disabled={
            showNewSection ||
            showNewPage ||
            showNewQuestion ||
            !isPageExpand(currOption[0], currOption[1])
          }
        >
          <AiOutlinePlus />
          Question
        </button> */}
      </div>

      <div className="options_tree">
        {(showNewQuestionOption || questionOptions.length === 0) && (
          <div
            id="new_section"
            className={`section cont selected`}
            onClick={() => setCurrOption([questionOptions.length])}
          >
            <SVGIcon src={Icons.PointFill} /> <p>New question option</p>
          </div>
        )}
        {questionOptions.map((questionOption, i) => (
          <div key={i}>
            <div
              className={`section cont ${isSelect([i])} ${showQuestionOption.has(i) ? "rotate_svg" : ""
                }`}
              onClick={() => expandorContractQuestionOption(i)}
            >
              <SVGIcon src={Icons.TriangleFill} /> <p>{questionOption.type}</p>
            </div>
            {showNewOption && currOption[0] === i && (
              <div
                id="new_page"
                className={`page cont selected`}
                onClick={() =>
                  setCurrOption([i, questionOptions[i].options.length])
                }
              >
                <SVGIcon src={Icons.PointFill} /> <p>New Option</p>
              </div>
            )}
            {(showQuestionOption.has(i) || (showNewOption && currOption[0] === i)) &&
              questionOption.options.map((option, j) => (
                <div key={j}>
                  <div
                    className={`page cont ${isSelect([i, j])}`}
                    // ${isSelect([i, j])} ${
                    //   isPageExpand(i, j) ? "rotate_svg" : ""
                    // }
                    onClick={() => setCurrOption([i, j])}
                  // onClick={() => expandorContractPage(i, j)}
                  >
                    <SVGIcon src={Icons.PointFill} /> <p>{option.title}</p>
                  </div>
                  {/* {showNewQuestion &&
                    currOption[0] === i &&
                    currOption[1] === j && (
                      <div
                        className={`question cont selected`}
                        onClick={() =>
                          setCurrOption([
                            i,
                            j,
                            sections[1].pages[j].questions.length,
                          ])
                        }
                      >
                        <p>New Question</p>
                      </div>
                    )} */}
                  {/* {isPageExpand(i, j) &&
                    page.questions.map(({ question }, k) => (
                      <div
                        key={k}
                        className={`question cont ${isSelect([i, j, k])}`}
                        onClick={() => setCurrOption([i, j, k])}
                      >
                        <p>{question}</p>
                      </div>
                    ))} */}
                </div>
              ))}
          </div>
        ))}
      </div>

      <div className="options">
        <button
          onClick={moveOptionUp}
          disabled={showNewOption || showNewQuestionOption || currOption.length < 2 || currOption[1] === 0}
        >
          <SVGIcon src={Icons.ArrowShort} rotation={180} />
          Move&nbsp;Up
        </button>
        <button
          onClick={moveOptionDown}
          disabled={showNewOption || showNewQuestionOption || currOption.length < 2 || currOption[1] === questionOptions[currOption[0]].options.length - 1}
        >
          <SVGIcon src={Icons.ArrowShort} />
          Move&nbsp;Down
        </button>
      </div>
    </div>
  );
};

export default SideBar;
